import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { SortService } from '@app/components/sorting/SortService';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { MenuItem, SelectItem } from 'primeng/api';
import { StatisticsService } from '@app/services/Statistics/Statistics.service';
import { CSVDataService } from '@app/export/CSVDataService';
import { NavigationEnd, Router } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-attendance-per-institution-within-institution-district',
  templateUrl: './attendance-per-institution-within-institution-district.component.html'
})

export class AttendancePerInstitutionWithinInstitutionDistrictComponent implements OnInit {
  form;
  
  institutionslist: SelectItem[] = [];
  selected;
  selectedyear;
  institutionlist;
  result: any[] = [];
  total;
  items: MenuItem[];
 

  constructor(
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private router: Router,
    private institutionService: InstitutionsService,
    private statisticsService: StatisticsService) {
    this.router.events.subscribe(x => {
      if (x instanceof NavigationEnd) {
        this.clear();
      }
    });
  }

  ngOnInit() {
    this.form = this.fb.group({
      institutionId: ['', ''],
      year: ['', Validators.required]
    });
  
    this.getAllInstitutions();
  }


  setItems() {
    this.items = [
      {
        label: 'Excel',
        icon: 'fa fa-file-excel',
        command: () => this.exportToCSV()
      }];
  }

  exportToCSV() {
    const firstrow = 'Besökare från institution;År;Antal besök;Distrikt;Besökt institution';
    const datum = this.datePipe.transform(new Date(), 'yy-MM-dd');
    const filnamn = 'NärvaroPerInstitutionInomInstitutionensDistrikt_' + datum;
    let data: any[] = [];
    this.result.forEach(x => {
      const row = {
        col1: x.visitors,
        col2: x.year,
        col3: x.visitorsCount,
        col4: x.district,
        col5: x.visited
      };
      data.push(row);

    });
    const totalrow = {
      col1: 'Totalt:',
      col2: '',
      col3: this.total,
      col4: '',
      col5: ''
    }
    data.push(totalrow);
    CSVDataService.exportToCsv(filnamn + '.csv', data, firstrow);
  }

  getAllInstitutions() {
    this.institutionService.getInstitutions().subscribe(response => {
      this.institutionlist = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });
      this.institutionlist.forEach(x => {
        x.name = x.shortName + ' ' + x.name;
      });
      this.institutionlist = this.institutionlist.filter(x => ((x.name)).toLowerCase().indexOf('distrikt') === -1);
      const removelist = ['AV1', 'AVGBREV1', 'UT1', 'EL', 'ELA', 'K', 'RLK1', 'RR1', 'SOFT1', 'SOFT2', 'SL1', 'SGL1'];
      this.institutionlist = this.institutionlist.filter(x => {
        return removelist.indexOf(x.shortName) === -1;
      });
      this.institutionlist.forEach(c => {
        this.institutionslist.push({ label: c.name, value: c.id });
      });
    });
  }

  setSingleInstitution(evt) {
    this.form.get('institutionId').setValue(+evt.value);
 
  }

  setYear(evt) {
    this.form.get('year').setValue(this.selectedyear);
  }

  search() {
    const statisticsInput = {
      generalStatisticsReportInputModel: {
        institutions: [this.form.value.institutionId],
        selectedYears: [this.form.value.year],
      }
    };
    this.statisticsService.GetAttendanceStatisticsPerInstitutionWithinDistrictReport(statisticsInput).subscribe((response: any) => {
      this.result = response;
      this.total = this.result.map(a => a.visitorsCount).reduce(function (a, b) {
        return a + b;
      });
      this.setItems();
    });
  }

  clear() {
    this.form?.reset();
    this.result = [];
  }
}
